export default __webpack_public_path__ + "static/media/notification1.4aea9c59.mp3";